import moment from "moment";
import React from "react";
import {FORMAT_TIME} from "types/enums";
import {ColumnProps} from "types/models";
import StatusCard from "../StatusCard/StatusCard";

const allColumns: ColumnProps[] = [
  {
    key: "index",
    title: "STT",
    show: true,
    isResizable: true,
    dataIndex: "index",
    render(value, record, index) {
      return <>{index + 1}</>;
    },
    width: 60,
    align: "center",
  },
  {
    key: "maBenhNhan",
    title: "Mã BN",
    show: true,
    isResizable: true,
    align: "center",
    dataIndex: "maBenhNhan",
    width: 60,
  },
  {
    title: "Mã PK",
    key: "maKB",
    align: "center",
    show: true,
    isResizable: true,
    dataIndex: "maKB",
    width: 60,
  },
  {
    title: "Mã đơn",
    key: "id",
    align: "center",
    show: true,
    isResizable: true,
    dataIndex: "id",
    width: 60,
  },
  {
    title: "Tên bệnh nhân",
    key: "hoTen",
    show: true,
    isResizable: true,
    dataIndex: "hoTen",
    width: 160,
  },
  {
    title: "Ngày sinh",
    key: "ngaySinh",
    show: true,
    isResizable: true,
    align: "center",
    dataIndex: "ngaySinh",
    render(value, record, index) {
      return <>{value ? moment(value).format(FORMAT_TIME.dayFull) : null}</>;
    },
    width: 100,
  },
  {
    title: "Giới tính",
    key: "gioiTinh",
    show: true,
    isResizable: true,
    dataIndex: "gioiTinh",
    render(value, record, index) {
      return <>{value == "NA" ? "Nam" : value == "NU" ? "Nữ" : ""}</>;
    },
    width: 80,
  },
  {
    title: "Thời gian tạo",
    key: "createDate",
    show: true,
    isResizable: true,
    align: "center",
    dataIndex: "createDate",
    render(value, record, index) {
      return <>{value ? moment(value).format(FORMAT_TIME.dateTime) : null}</>;
    },
    width: 150,
  },
  {
    title: "Thời gian bán",
    key: "thoiGianBan",
    show: true,
    isResizable: true,
    align: "center",
    dataIndex: "thoiGianBan",
    render(value, record, index) {
      return <>{value ? moment(value).format(FORMAT_TIME.dateTime) : null}</>;
    },
    width: 150,
  },
  {
    title: "Thời gian trả",
    key: "thoiGianTra",
    show: true,
    isResizable: true,
    align: "center",
    dataIndex: "thoiGianTra",
    render(value, record, index) {
      return <>{value ? moment(value).format(FORMAT_TIME.dateTime) : null}</>;
    },
    width: 150,
  },
  {
    title: "Bác sĩ",
    key: "tenBacSy",
    show: true,
    isResizable: true,
    dataIndex: "tenBacSy",
    width: 180,
  },
  {
    title: "Trạng thái đơn",
    key: "status",
    show: true,
    isResizable: true,
    dataIndex: "status",
    align: "center",
    render(value, record, index) {
      return <StatusCard status={value}></StatusCard>;
    },
    width: 100,
  },
  {
    title: "Ghi chú",
    key: "ghiChu",
    show: true,
    isResizable: true,
    dataIndex: "ghiChu",
    width: 100,
  },
];
export {allColumns};
